import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { DesitionBoxComponent } from 'src/app/modales/desition-box/desition-box.component';
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';
import { UsersServiceService } from 'src/app/services/users-service.service';
import { MatTableDataSource } from '@angular/material/table'; // Importa MatTableDataSource

@Component({
  selector: 'app-user-mannager',
  templateUrl: './user-mannager.component.html',
  styleUrls: ['./user-mannager.component.scss'],
  standalone: false
})
export class UserMannagerComponent implements OnInit {
  length = 0; // Inicializa length a 0
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  data: any[] = [];
  isLoading = false;
  displayedColumns: string[] = ['position', 'nombre', 'licencia', 'correo', 'editar', 'eliminar'];
  dataSource = new MatTableDataSource<any>(); // Usa MatTableDataSource

  formulario = new FormGroup({
    busqueda: new FormControl("", [])
  });

  constructor(private _user: UsersServiceService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.buscar();
  }

  handlePageEvent(event: PageEvent) {
    this.pageEvent = event;
    this.pageSize = event.pageSize;
    this.updatePagedData();
  }

  updatePagedData() {
    const startIndex = this.pageEvent ? this.pageEvent.pageIndex * this.pageSize : 0;
    const endIndex = startIndex + this.pageSize;
    const pagedData = this.data.slice(startIndex, endIndex);
    this.dataSource.data = pagedData; // Actualiza dataSource.data
  }

  buscar() {
    this.isLoading = true;
    this._user.findUsers(this.formulario.controls["busqueda"].value).subscribe(result => {
      this.isLoading = false;
      if (result.code == 200 && result.datos.usuarios.length > 0) {
        this.data = result.datos.usuarios; // Guarda los datos en this.data
        this.length = this.data.length; // Actualiza length
        this.updatePagedData(); // Actualiza dataSource.data con los datos paginados
      } else {
        this.dialog.open(MessageBoxComponent, {
          data: { title: "Usuario no encontrado", text: "No se encontraron usuarios con los criterios de búsqueda.", icon: "error_outline" }
        });
        this.data = []; // resetea data
        this.length = 0; // resetea length
        this.dataSource.data = []; // resetea dataSource
      }
    }, error => {
      this.isLoading = false;
      this.dataSource.data = [];
      this.data = [];
      this.length = 0;
      console.info(error);
    });
  }

  delete(id: number) {
    this.openDialog(id);
  }

  openDialog(id: number): void {
    const dialogRef = this.dialog.open(DesitionBoxComponent, {
      data: { title: "Solicitud de confirmación", text: "¿Está seguro que desea eliminar el usuario?", icon: "help_outline" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        this._user.deleteUserById(id).subscribe(resulta2 => {
          if (resulta2.code == 200) {
            this.isLoading = false;
            this.buscar();
          }
        }, error => {
          this.isLoading = false;
          console.info(error);
        });
      }
    });
  }
}